export default function queryly() {
  return `<script type="text/javascript" src="//www.queryly.com/js/queryly.v4.js" defer></script><script type="text/javascript" defer src="//www.queryly.com/js/fastcompany-advanced-search.js"></script>`;
}
